import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const courseSingleTableHeadings = [
	{ data: 'ID', title: 'ID' },
	{ data: 'displayName', title: ls('Name') },
	{ data: 'firstName', title: ls('First Name') },
	{ data: 'lastName', title: ls('Last Name') },
	{ data: 'userLogin', title: ls('Username') },
	{ data: 'email', title: ls('Email Address') },
	{ data: 'quizAvg', title: ls('Quiz Average') },
	{ data: 'completionDate', title: ls('Completion Date') },
	{ data: 'percentComplete', title: ls('% Complete'), className: 'no-sort' },
	{ data: 'details', title: reportingApiSetup.localizedStrings.tablesColumnsDetails, className: 'no-sort' }
];

const courseSingleTableData = function(courseID) {
	let userList = dataObject.userList;
	let courseType,
		userAccess,
		courseSingleTableData = [],
		userDisplayName,
		userCompletionDate,
		percentCompleted,
		completionTime,
		timeSpent;

	courseType = dataObject.courseList[courseID].course_price_type;

	// Check enrollment
	if ('open' === courseType) {
		userAccess = userList.allUserIds;
	} else {
		userAccess = dataObject.userList.course_user_access_list[courseID];
	}

	jQuery.each(userAccess, function (key, userID) {
		if (typeof userList.userOverview[userID] === 'undefined') {
			return true;
		}

		let userData = userList.userOverview[userID];

		if (
			typeof userList.userOverview[userID].completed_on !== 'undefined'
			&& typeof userList.userOverview[userID].completed_on[courseID] !== 'undefined'
		) {
			userCompletionDate = userList.userOverview[userID].completed_on[courseID];
		} else {
			userCompletionDate = { display: "", timestamp: '0' };
		}

		percentCompleted = ls('Not Started');
		completionTime = '';
		timeSpent = '';

		if (typeof userData[courseID] !== 'undefined') {
			if (typeof userData[courseID].completed_on !== 'undefined') {
				userCompletionDate = userData[courseID].completed_on;
			}

			if (0 !== userData[courseID].completed) {
				percentCompleted = Math.ceil(userData[courseID].completed / userData[courseID].total * 100) + '%';
			}

			if (typeof userData[courseID].completed_time !== 'undefined') {
				completionTime = dataObject.formatSecondsToDate(userData[courseID].completed_time);
			}

			if (typeof userData[courseID].time_spent !== 'undefined') {
				timeSpent = dataObject.formatSecondsToDate(userData[courseID].time_spent);
			}
		}

		// Actions
		let href = `${reportingApiSetup.reportingLinks.userReport}&user=${userID}&course=${courseID}`;
		let details = `<a class="reporting-table-see-details--link" href="${href}">${reportingApiSetup.localizedStrings.tablesButtonSeeDetails}</a>`;

		// User Display Name
		userDisplayName = `<span class="reporting-table-see-details">${userData.display_name}</span>`;

		let rowData = {
			ID: userID,
			displayName: userData.display_name,
			firstName: userData.first_name,
			lastName: userData.last_name,
			userLogin: userData.user_login,
			email: userData.user_email,
			quizAvg: '',
			completionDate: userCompletionDate,
			percentComplete: (ls('Not Started') === percentCompleted) ? '' : percentCompleted,
			details: details
		};

		if (isDefined(wp.hooks)) {
			rowData = wp.hooks.applyFilters('tc_table_data_drawcourseSingleTableData', rowData);
		}

		courseSingleTableData.push(rowData);
	});

	return courseSingleTableData;
};

const drawcourseSingleTableData = function(response, dataTableInstance) {
	dataObject.additionalData['courseSingleTable'] = response.additionalData;
	let tableType = 'courseSingleTable';

	for (let row in response.data) {
		let rowData = reportingTables.tableObjects[tableType].row(row).data();

		rowData.completionDate = response.data[row].completed_date;
		rowData.percentComplete = response.data[row].progress + '%';

		if ('' === response.data[row].quiz_average) {
			rowData.quizAvg = response.data[row].quiz_average;
		} else {
			rowData.quizAvg = response.data[row].quiz_average + '%';
		}

		if (isDefined(wp.hooks)) {
			rowData = wp.hooks.applyFilters('tc_table_data_drawcourseSingleTableData', rowData, row, response);
		}

		reportingTables.tableObjects[tableType].row(row).data(rowData);
	}

	reportingTables.tableObjects[tableType].draw('page');

	reportingTables.tableDrawActive['courseSingleTable'] = false;

	if (typeof reportingTables.triggerCSV['courseSingleTable'] !== 'undefined') {
		if (false !== reportingTables.triggerCSV['courseSingleTable']) {
			var csv = reportingTables.triggerCSV['courseSingleTable'];

			if (jQuery.fn.dataTable.ext.buttons.csvHtml5.available(csv.dt, csv.config)) {
				jQuery.fn.dataTable.ext.buttons.csvHtml5.action.call(dataTableInstance, csv.e, reportingTables.tableObjects[tableType], csv.button, csv.config, csv.cb );
			}
		}
	}

	reportingTables.triggerCSV['courseSingleTable'] = false;
};

const drawcourseSingleTableDataExcel = function(response, dataTableInstance) {
	dataObject.additionalData['courseSingleTable'] = response.additionalData;
	let tableType = 'courseSingleTable';

	for (let row in response.data) {
		let rowData = reportingTables.tableObjects[tableType].row(row).data();

		rowData.completedDate = response.data[row].completed_date;
		rowData.percentComplete = response.data[row].progress + '%';

		if ('' === response.data[row].quiz_average) {
			rowData.quizAvg = response.data[row].quiz_average;
		} else {
			rowData.quizAvg = response.data[row].quiz_average + '%';
		}

		if (isDefined(wp.hooks)) {
			rowData = wp.hooks.applyFilters('tc_table_data_drawcourseSingleTableData', rowData, row, response);
		}

		reportingTables.tableObjects[tableType].row(row).data(rowData);
	}

	reportingTables.tableObjects[tableType].draw('page');

	reportingTables.tableDrawActive['courseSingleTable'] = false;

	if (typeof reportingTables.triggerExcel['courseSingleTable'] !== 'undefined') {
		if (false !== reportingTables.triggerExcel['courseSingleTable']) {
			var excel = reportingTables.triggerExcel['courseSingleTable'];

			if (jQuery.fn.dataTable.ext.buttons.excelHtml5.available(excel.dt, excel.config)) {
				jQuery.fn.dataTable.ext.buttons.excelHtml5.action.call(dataTableInstance, excel.e, reportingTables.tableObjects[tableType], excel.button, excel.config, excel.cb );
			}
		}
	}

	reportingTables.triggerExcel['courseSingleTable'] = false;
};

export {
	courseSingleTableHeadings,
	courseSingleTableData,
	drawcourseSingleTableData,
	drawcourseSingleTableDataExcel
};
